import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { SharedModule } from '../../shared/shared.module';;
import {AboutComponent} from './about.component';
import { OwlModule} from 'angular-owl-carousel';

@NgModule({
	declarations: [
		AboutComponent
	],

	imports: [
		CommonModule,
		RouterModule,
		NgbModule,
		SharedModule,
		OwlModule,
		LazyLoadImageModule
	]
})

export class AboutModule { }
